import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import AppContainer from "../Structure/AppContainer";
import AuthContext from "../../Context/AuthContext";
import useStateCallback from "../../util/customHooks/useStateCallback";
import SupplierInvoiceDetailsModal from "../SupplierIvoices/SupplierInvoiceDetailsModal";
import ajaxSupplierInvoicesPayments from "../../util/remote/ajaxSupplierInvoicesPayments";
const ViewSupplierInvoices = () => {
  const { userId } = useContext(AuthContext);
  const navigate = useNavigate();
  // State
  const [loading, setLoading] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [meta, setMeta] = useState([]);
  const [page, setPage] = useState(1);
  // Date filters
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  useEffect(() => {
    const today = new Date();
    const localDate = today.toLocaleDateString("en-CA");
    setToDate(localDate);
  }, []);
  // Modals
  const [view_details, setView_details] = useStateCallback(false);
  // Fetch invoices
  const fetchSupplierInvoices = async () => {
    setLoading(true);
    const data = {
      page,
      from_date: fromDate || "",
      to_date: toDate || "",
    };
    const server_response =
      await ajaxSupplierInvoicesPayments.fetchSupplierInvoicesPayments(data);
    setLoading(false);
    if (server_response.status === "OK") {
      setInvoices(server_response.details.list);
      setMeta(server_response.details.meta.list_of_pages);
    } else {
      toast.error(server_response.message);
    }
  };
  useEffect(() => {
    fetchSupplierInvoices();
  }, [page]);
  // Pagination handlers
  const setNextPageNumber = () => {
    if (page < meta.length) setPage(page + 1);
  };
  const setPreviousPageNumber = () => {
    if (page > 1) setPage(page - 1);
  };
  const setPageNumber = (e, item) => {
    e.preventDefault();
    setPage(item);
  };
  // Modal handler
  const handleView_details = (invoiceId) => {
    setView_details(false, () =>
      setView_details(
        <SupplierInvoiceDetailsModal
          invoiceId={invoiceId}
          onClose={() => setView_details(false)}
        />
      )
    );
  };
  const handleFilter = () => {
    setPage(1);
    fetchSupplierInvoices();
  };
  const handleResetFilters = () => {
    setFromDate("");
    const today = new Date().toISOString().split("T")[0];
    setToDate(today);
    setPage(1);
    fetchSupplierInvoices();
  };
  return (
    <AppContainer title="Supplier Invoices Payments View">
      <div className="container-fluid">
        <Toaster />
        {view_details}
        {/* Create button */}
        <div className="row mb-3">
          <div className="col-lg-3">
            <button
              className="btn btn-primary btn-sm shadow-sm"
              onClick={() => navigate("/supplier_payment/pay")}
            >
              <i className="fa fa-plus me-2"></i> Pay Supplier
            </button>
          </div>
        </div>
        {/* Filters */}
        <div className="card shadow-sm mb-4 border-0">
          <div className="card-header bg-light fw-bold">
            <i className="fa fa-filter me-2"></i> Filter Supplier Invoices
          </div>
          <div className="card-body">
            <div className="row g-3">
              <div className="col-lg-3">
                <label className="form-label">From Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>
              <div className="col-lg-3">
                <label className="form-label">To Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
              <div className="col-lg-3 d-flex align-items-end">
                <button className="btn btn-success me-2" onClick={handleFilter}>
                  <i className="fa fa-search me-1"></i> Filter
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={handleResetFilters}
                >
                  <i className="fa fa-undo me-1"></i> Reset
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Table */}
        <div className="card shadow-sm border-0">
          <div className="card-header bg-light fw-bold">
            <i className="fa fa-list me-2"></i> Organisation Supplier Invoices
          </div>
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Invoice No</th>
                    <th>Invoice Amount</th>
                    <th>Balance</th>
                    <th>Payment Method</th>
                    <th>Payment Amount</th>
                    <th>Invoice Date</th>
                    <th>Payment Date</th>
                    <th>Created By</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(invoices) && invoices.length > 0 ? (
                    invoices.map((inv, key) => (
                      <tr key={inv.id}>
                        <td>{key + 1}</td>
                        <td>{inv.invoice_no}</td>
                        <td>{inv.invoice_amount}</td>
                        <td>{inv.invoice_balance}</td>
                        <td>{inv.payment_method}</td>
                        <td>{inv.amount}</td>
                        <td>{inv.invoice_date}</td>
                        <td>{inv.date_created}</td>
                        <td>{inv.created_by}</td>
                        <td className="text-center">
                          <button
                            className="btn btn-sm btn-outline-info"
                            onClick={() => handleView_details(inv.InvoiceID)}
                          >
                            <i className="fa fa-eye me-1"></i> Details report
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10" className="text-center py-3">
                        {loading ? "Loading invoices..." : "No records found"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {/* Pagination */}
          <div className="card-footer bg-light">
            <nav className="d-flex justify-content-center">
              <ul className="pagination mb-0">
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={setPreviousPageNumber}
                    disabled={page === 1}
                  >
                    Prev
                  </button>
                </li>
                {Array.isArray(meta) &&
                  meta.map((item) =>
                    page === item ? (
                      <li className="page-item active" key={item}>
                        <span className="page-link">{item}</span>
                      </li>
                    ) : (
                      <li className="page-item" key={item}>
                        <a
                          className="page-link"
                          href="#!"
                          onClick={(e) => setPageNumber(e, item)}
                        >
                          {item}
                        </a>
                      </li>
                    )
                  )}
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={setNextPageNumber}
                    disabled={page === meta.length || meta.length === 0}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </AppContainer>
  );
};
export default ViewSupplierInvoices;
